import {
  getAuthSession,
  printDebugLog,
  updateProfileOnChangeOfSession
} from "../constants/constant";

export const setCartType = cartType => {
    return (dispatch) => new Promise((resolve, reject) => {
        dispatch({
            type: "SET_CART_TYPE",
            cartType: cartType
        })
    })
}

export const setActiveShopHash = activeShopHash => {
    //console.log("activeShopHash => ",activeShopHash);
    updateProfileOnChangeOfSession(activeShopHash,
        activeShopHash.kotCopiesAllowed,
        activeShopHash.defBalanceType, activeShopHash.defScreen, activeShopHash.defBillUi);

    return (dispatch) => new Promise((resolve, reject) => {
        dispatch({
            type: "SET_ACTIVE_HASH",
            activeShopHash: activeShopHash
        })
    })
}

export const setActiveShopHashFromLogin = activeShopHash => {
    //console.log("activeShopHash => ",activeShopHash);
    updateProfileOnChangeOfSession(activeShopHash,
        getAuthSession().kotCopiesAllowed,
        getAuthSession().defBalanceType, getAuthSession().defScreen, getAuthSession().defBillUi
    );
    return (dispatch) => new Promise((resolve, reject) => {
        dispatch({
            type: "SET_ACTIVE_HASH",
            activeShopHash: activeShopHash
        })
    })
}


export const setApiUrl = BASE_URL => {
    //console.log("setApiUrl",BASE_URL);
    return (dispatch) => new Promise((resolve, reject) => {
        dispatch({
            type: "SET_URL_TYPE",
            BASE_URL: BASE_URL
        })
    })
}

export const setBaseCateogoryData = cateogoryData => {
    printDebugLog("setBaseCateogoryData", cateogoryData);
    return (dispatch) => new Promise((resolve, reject) => {
        dispatch({
            type: "SET_CATEOGORY_DATA",
            cateogoryData: cateogoryData
        })
    })
}

export const setBaseProductData = productData => {
    printDebugLog("setBaseProductData", productData);
    return (dispatch) => new Promise((resolve, reject) => {
        dispatch({
            type: "SET_PRD_DATA",
            productData: productData
        })
    })
}
